module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('edit-pane', {
    ref: "ins",
    attrs: {
      "prefix": "Insurance: ",
      "title": _vm.ins.policyType,
      "editable": _vm.isManager('finance|property|admin') ? true : false,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "inline": true,
      "label-position": "left",
      "label-wdith": "120px"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-row', [_c('h4', [_vm._v("Policy")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('select-insurance-policy-type', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.policyType),
      callback: function($$v) {
        _vm.$set(_vm.ins, "policyType", $$v)
      },
      expression: "ins.policyType"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "label": "Policy No.",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.policyNo),
      callback: function($$v) {
        _vm.$set(_vm.ins, "policyNo", $$v)
      },
      expression: "ins.policyNo"
    }
  }), _vm._v(" "), _c('el-row', [_c('date-input', {
    attrs: {
      "label": "Started",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.coverageStart),
      callback: function($$v) {
        _vm.$set(_vm.ins, "coverageStart", $$v)
      },
      expression: "ins.coverageStart"
    }
  }), _vm._v(" "), _c('date-input', {
    attrs: {
      "label": "Expiry",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.coverageEnd),
      callback: function($$v) {
        _vm.$set(_vm.ins, "coverageEnd", $$v)
      },
      expression: "ins.coverageEnd"
    }
  })], 1), _vm._v(" "), (_vm.canAccess('finance|admin')) ? _c('float-input', {
    attrs: {
      "label": "Premium",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.premium),
      callback: function($$v) {
        _vm.$set(_vm.ins, "premium", $$v)
      },
      expression: "ins.premium"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.canAccess('finance|admin')) ? _c('float-input', {
    attrs: {
      "label": "Insured Amount",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.insuredAmount),
      callback: function($$v) {
        _vm.$set(_vm.ins, "insuredAmount", $$v)
      },
      expression: "ins.insuredAmount"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 23,
      "md": 11,
      "lg": 11,
      "offset": 1
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h4', [_vm._v("Insurer")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n        Insurer\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [(_vm.disabled) ? _c('strong', [_vm._v(_vm._s(_vm.provider.name) + " ")]) : _c('select-insurer', {
    attrs: {
      "label": "",
      "callback": _vm.orgChange,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.ins.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.ins, "organisation_id", $$v)
      },
      expression: "ins.organisation_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n        Address\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.provider.address) + " ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n        Post Code\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.provider.postCode) + " ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n        Phone\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.provider.phone) + " ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("\n        e-Mail\n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('strong', [(_vm.ins.policyNo) ? _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.provider.email +
        '?subject=RE: Policy No ' + _vm.ins.policyNo
    }
  }, [_vm._v(_vm._s(_vm.provider.email))]) : _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.provider.email
    }
  }, [_vm._v(_vm._s(_vm.provider.email))])])])], 1)], 1)], 1), _vm._v(" "), (_vm.canAccess('finance|admin') && _vm.ins.site_id && _vm.ins.id) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('files-panel', {
    attrs: {
      "title": "Policy Document",
      "type": "site",
      "id": _vm.ins.site_id,
      "process": "insurance",
      "process-id": _vm.ins.id
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56f1cb62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/insurance/InsurancePolicy.vue
// module id = 1500
// module chunks = 0